import { render, staticRenderFns } from "./RMBIRBitableReport.vue?vue&type=template&id=e955b8de&scoped=true&"
import script from "./RMBIRBitableReport.vue?vue&type=script&lang=ts&"
export * from "./RMBIRBitableReport.vue?vue&type=script&lang=ts&"
import style0 from "./RMBIRBitableReport.vue?vue&type=style&index=0&id=e955b8de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e955b8de",
  null
  
)

export default component.exports